/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

import {
  IGetCredentialIssuedListProps,
  UpdateStatusProps,
} from "./components";

const is = require("is_js");

const SERVICE_NAME = "PayoutListPageService";
const log: any = LoggerModule.getInstance();

export type IPayoutCredentialPageSrvGetPageContentArgs =
  IGetCredentialIssuedListProps;

export class PayoutListPageService {
  private static instance: PayoutListPageService;
  private vapp: VApplication;
  private criteria: any;
  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): PayoutListPageService {
    if (!PayoutListPageService.instance) {
      PayoutListPageService.instance = new PayoutListPageService(props);
    }
    return PayoutListPageService.instance;
  }

  private setCriteria(data: any) {
    this.criteria = [...this.criteria, ...data];
  }

  public resetCriteria() {
    this.criteria = [];
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    return content;
  }

  public async getPageContent(
    args: IPayoutCredentialPageSrvGetPageContentArgs
  ) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    // if (args?.where) {
    //   this.setCriteria(args?.where);
    // }

    //Settings Props
    compProps = await agent.getSettingsProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //event timeline

    compProps = await agent.getEventTimelineProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async updateStatus(args: UpdateStatusProps) {
    console.log(`update status id`, args);
    const agent = getAgent();
    return agent.getUpdateStatus(args);
  }

  public async resendCred(args: UpdateStatusProps) {
    const agent = getAgent();
    return agent.getResendCredential(args);
  }

  public async getPolicyList(args:any){
    console.log(`args in service index`, this.criteria);
    if (args?.where?.length > 0) {
      this.setCriteria(args?.where);
    }

    const agent = getAgent();
    if(Array.isArray(this.criteria) &&this.criteria?.length > 0){
      return agent.getPolicyListsProps({
        ...args,
        where:[...args?.where, ...this.criteria]
      });
    }
    else {
      return agent.getPolicyListsProps({
        ...args,
        where:[...args?.where]
      }); 
    }
    // return content;
  }

  public getEventDetail(args:any){
    const agent =getAgent();
    return agent.getEventDetailSync(args);
  }

  public async getButtons(args:any){
    const agent = getAgent();
    return await agent.getButtonProps(args);
  }
}
